import { AxiosResponse } from "axios";

import API from "../../api";

import { Despatch } from "../../models/despatch";

const ROUTE_NAME = "route/tasks";

const RoutePlannerTaskService = {
  async create(despatch: Despatch): Promise<AxiosResponse<Despatch>> {
    return await API.post(`/${ROUTE_NAME}`, despatch);
  },
  async update(id: string, despatch: Despatch): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, despatch);
  },
  async delete(id: number): Promise<AxiosResponse<Despatch>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
  async createList(despatches: Despatch[]): Promise<AxiosResponse<Despatch[]>> {
    return await API.post(`/${ROUTE_NAME}/list`, despatches)
  },
  async deleteList(despatches: Despatch[]): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/delete/list`, despatches)
  }
};

export default RoutePlannerTaskService;
